import { helpers } from "@vuelidate/validators"
import type { Moment } from "moment"
import type { RecurringAvailability } from "@/models/recurring-availability.model.ts"

export { chronologicalStartAndEndTimeValidator } from "@/helper/validation/time-validation.ts"

/**
 * Validates that a time value (timeStart or timeEnd) is present.
 */
export const startAndEndTimeRequiredValidator = helpers.withMessage(
  "De start- en eindtijd zijn verplicht.",
  (value: Moment | null) => !!value
)

/**
 * Validates that a recurring availability does not overlap with any sibling slots
 * of the same availability type on the same day.
 * Overlap between AVAILABLE and UNAVAILABLE slots is allowed (e.g. "available all day
 * except 12:00–13:00").
 */
export function timeNoOverlapValidator(sibilingRecurringAvailabilities: RecurringAvailability[]) {
  return helpers.withMessage(
    "Tijdsloten mogen elkaar niet overlappen.",
    (ra: RecurringAvailability) => {
      if (!ra.timeStart || !ra.timeEnd) {
        return true
      }

      return !sibilingRecurringAvailabilities.some((other) => {
        if (
          other === ra ||
          !other.timeStart ||
          !other.timeEnd ||
          other.availabilityType !== ra.availabilityType
        ) {
          return false
        }
        return ra.timeStart!.isBefore(other.timeEnd) && ra.timeEnd!.isAfter(other.timeStart)
      })
    }
  )
}
